import { render, staticRenderFns } from "./ValidateResult.vue?vue&type=template&id=844ab3a8&scoped=true&lang=pug&"
import script from "./ValidateResult.vue?vue&type=script&lang=js&"
export * from "./ValidateResult.vue?vue&type=script&lang=js&"
import style0 from "./ValidateResult.vue?vue&type=style&index=0&id=844ab3a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844ab3a8",
  null
  
)

export default component.exports